module.exports = __webpack_public_path__ + "html/different-devices_046be7f22484750b8d0d1652499f9c05.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/different-devices.html
// module id = 99ze
// module chunks = 72